import React from 'react';
import { makeStyles } from '@material-ui/core/styles';

import { errorRed, errorYellow } from 'on_web/assets/imageList';
import { Grid, Box, Container } from '@material-ui/core';
import Button from 'on_web/components/shared/Common/Button';
import Header from 'on_web/components/shared/Menu/Header/Header';
import PageItemContainer from 'on_web/components/shared/Common/PageItemContainer/PageItemContainer';

export default function ErrorMessageTile(props) {
  const useStyles = makeStyles({
    title: {
      fontFamily: 'Museo-900',
      fontSize: 15,
    },
    message: {
      fontFamily: 'Museo-500',
      fontSize: 15,
    },
  });
  const classes = useStyles();

  const renderContent = () => {
    return (
      <Box m={props.isPage ? 3 : 0}>
        <Grid
          container
          direction="column"
          justify="flex-start"
          alignItems="center"
        >
          {props.level === 'warning' && (
            <Grid item>
              <img alt="error_image" src={errorYellow} width={220} />
            </Grid>
          )}
          {props.level === 'error' && (
            <Grid item>
              <img alt="error_image" src={errorRed} width={220} />
            </Grid>
          )}
          <Grid item>
            <Box className={classes.title}>
              {props.title ?? 'Well, this is awkward…'}
            </Box>
          </Grid>
          <Grid item>
            <Box className={classes.message} textAlign="center">
              {props.message ??
                'Seems like we’re experiencing a problem. We’ve alerted our team, but in the meantime, click below to reload the page.'}
            </Box>
          </Grid>
          <Grid item>
            {props.onButtonClick && (
              <Box py={2}>
                <Button
                  style={{ width: '188px' }}
                  backgroundGradient={
                    'linear-gradient(to right, #194378, #30eaff)'
                  }
                  onClick={props.onButtonClick}
                >
                  {props.actionText ?? 'TRY AGAIN'}
                </Button>
              </Box>
            )}
          </Grid>
          <Grid item>{props.children}</Grid>
        </Grid>
      </Box>
    );
  };

  return props.isPage ? (
    <Container>
      <PageItemContainer>
        <Header />

        <Box
          display="flex"
          flexDirection="column"
          justifyContent="center"
          alignItems="center"
          minHeight="80vh"
        >
          {renderContent()}
        </Box>
      </PageItemContainer>
    </Container>
  ) : (
    renderContent()
  );
}
